// Kept free of component imports so both the action cell and the modal host can
// depend on it without pulling the modal trees into the grid's module graph.
export const PRICER_ROW_ACTION_MODAL = {
  TRADE: "trade",
  OTHER_INFO: "otherInfo",
  UPDATE_OPTION: "updateOption",
  PUSH_OPTION: "pushOption",
  PUSH_TO_AUDIT_TRAIL: "pushToAuditTrail",
  ADDITIONAL_DATA: "additionalData",
  SHOW_FORMULAS: "showFormulas",
};
